import {use} from 'react'
import {BannerStackActionsContext, type BannerStackActionsContextValue} from './banner-stack-actions-context'

/**
 * Returns `{addBanner, dismissBanner, dismissAllBanners}` action
 * bundle.
 */
export function useBannerStackActions(): BannerStackActionsContextValue {
  return use(BannerStackActionsContext)
}

/**
 * Returns `(banner: BannerInput) => string` function. Calling it
 * adds a banner and returns its generated `id`, which can later be passed to
 * `useDismissBanner()` to remove it.
 */
export function useAddBanner(): BannerStackActionsContextValue['addBanner'] {
  return useBannerStackActions().addBanner
}

/**
 * Returns `(id: string, banner: Partial<BannerInput>) => void` function.
 * Calling it merges the given props into an existing banner (identified by
 * the id returned from `useAddBanner()`) in place, without removing and
 * re-adding it.
 */
export function useUpdateBanner(): BannerStackActionsContextValue['updateBanner'] {
  return useBannerStackActions().updateBanner
}

/** Returns `(id: string) => void` function that dismisses a banner by id. */
export function useDismissBanner(): BannerStackActionsContextValue['dismissBanner'] {
  return useBannerStackActions().dismissBanner
}

/**
 * Returns `(id: string) => void` function that moves focus to a banner's
 * rendered root element, identified by the id returned from `useAddBanner()`.
 * No-op if the banner isn't currently rendered (e.g. it was dismissed, or the
 * call happens before the banner has mounted).
 */
export function useFocusBanner(): BannerStackActionsContextValue['focusBanner'] {
  return useBannerStackActions().focusBanner
}
